export const CREATE = 'CREATE'
export const REPLACE = 'REPLACE'
export const UPDATE = 'UPDATE'
export const REMOVE = 'REMOVE'
